// SEND GROUP MESSAGE MESSAGE *********************************************************************
// pathname: /v3/bulk-operation/message/{jobSlug}
// ************************************************************************************************
import { useSwrMutationApi, PostSendGroupMessage } from 'src/hooks/useSwrApi';


/**
 * @description Sends message to all the selected applicants.
 * - If all applicants are selected, use the 'buildListByStatus' parameter (back-end will ignore the 'slugs' array).
 *
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param successCallback - callback function to be executed on success
 *
 * @example
 * // send message to all applicants with status 'interview' (3)
 * const { data, trigger } = useSwrSendGroupMessage(jobSlug, 'ro');
 * trigger({ buildListByStatus: 3, messageBody: 'Your message here' });
 *
 * // send message to selected applicants
 * trigger({ slugs: ['slug1', 'slug2'], messageBody: 'Your message here' });
 */
export const useSwrSendGroupMessage = (jobSlug: string, locale: string = 'ro', successCallback?: () => void) => {
  const {
    data,
    error,
    trigger,
    isMutating,
    reset,
  } = useSwrMutationApi<undefined, PostSendGroupMessage>({
    url: `/v3/bulk-operation/message/${jobSlug}`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
